import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { UserPermissionsService } from 'rome-library';
import { Observable } from 'rxjs';
import { UserCredentialStore } from '../../interfaceTypes/sharedFeatures/registration/services';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class DirectUserService extends UserService {
  constructor(
    httpClient: HttpClient,
    userPermissionService: UserPermissionsService,
    private readonly userCredentialStore: UserCredentialStore
  ) {
    super(httpClient, userPermissionService);
  }

  public getUserInfoEndpoint(): string {
    return '/DirectCustomer/currentUserInfo';
  }

  public getSendResetForgottenPasswordRequestEndpoint(): string {
    return '/DirectCustomer/sendResetForgottenPasswordRequest';
  }

  public getResetForgottenPasswordRequestEndpoint(): string {
    return '/DirectCustomer/resetForgottenPassword';
  }

  public getSecurityChallengeForPasswordResetRequestEndpoint(): string {
    return '/DirectCustomer/securityChallengeForPasswordResetRequest';
  }

  public getCheckSecurityQuestionAnswerForPasswordResetRequestEndpoint(): string {
    return '/DirectCustomer/checkSecurityQuestionAnswerForPasswordResetRequest';
  }

  public getResetPasswordEndpoint(): string {
    return '/DirectCustomer/resetUserPassword';
  }

  public acceptCookies(): Observable<any> {
    return this.httpClient.put('/DirectCustomer/acceptCookies', {});
  }

  public getCookiesResponse(): Observable<boolean> {
    return this.httpClient.get<boolean>('/DirectCustomer/hasAcceptedCookies', {});
  }

  public getWelcomeMessageFlag(): Observable<boolean> {
    return this.httpClient.get<boolean>('/DirectCustomer/getWelcomeMessageFlag');
  }

  public setUserData(data, password: string): Observable<[any, boolean, string]> {
    if (!data.ProfileComplete) {
      this.userCredentialStore.setPassword(password);
    } else {
      this.userCredentialStore.setPassword(undefined);
    }

    return super.setUserData(data, password);
  }
}
